import { useEffect } from 'react';
import { AnimatePresence, motion } from 'framer-motion';

const ArchiveLocationsList = (props) => {

  const { view, setIsArchiveCloseupView, siteData, selectedLocation, setSelectedLocation, layersListIsExpanded, locationsListIsExpanded, setLocationsListIsExpanded, setMenuIsActive } = props;

  useEffect(() => {
    if (layersListIsExpanded === true) {
      setLocationsListIsExpanded(false);
    }
  }, [layersListIsExpanded, setLocationsListIsExpanded]);

  return (
    <nav
      className={`archive__nav--panel nav--locations${locationsListIsExpanded === false ? ' condensed' : ''}${selectedLocation._id ? ' location-is-selected' : ''}`}
      onClick={() => setMenuIsActive(false)}
    >
      <div className="nav--archive__nav__inner">
        <button className={`archive__nav--panel__header button--plain ${locationsListIsExpanded === true ? 'open' : 'closed'}`}
          onClick={() => {
            setLocationsListIsExpanded(!locationsListIsExpanded);
          }}
        >
          <h2 className="archive__nav--panel__heading">filter by location</h2>
        </button>
        <ul className="archive__nav__list">
          <AnimatePresence>
            {
              siteData.locations &&
              siteData.locations.entries &&
              siteData.locations.entries.map(
                (item, i) => (
                  (locationsListIsExpanded === true || selectedLocation._id === item._id) &&
                  <motion.li className={`archive__nav__list__item${selectedLocation._id === item._id ? ' selected' : ''}`} key={i}>
                    <button
                      className="archive__nav__list__item__button button--plain"
                      onClick={(e) => {
												if (view === 'microfiche') {
													setIsArchiveCloseupView(true);
												}
                        e.preventDefault();
                        if (selectedLocation._id !== item._id) {
                          setSelectedLocation(item);
                        } else {
                          setSelectedLocation({});
                        }
                      }}
                    >
                      <p className="archive__nav__list__item__title">{item.title}</p>
                    </button>
                  </motion.li>
                )
              )
            }
          </AnimatePresence>
        </ul>
      </div>
    </nav>
  )
}

export default ArchiveLocationsList;